<template>
  <div class="admin-landing-page">
    <admin-view-header title="Pulpit administracyjny" />
    <notification icon="fa-user" type="is-success" without-delete>
      Zalogowano jako&nbsp;
      <strong>{{ loggedUser }}</strong>
    </notification>
    <notification icon="fa-clock" type="is-primary" without-delete>
      Sesja ważna do&nbsp;
      <strong>{{ jwtExpirationDate.format("HH:mm:ss, DD.MM.YYYY") }}</strong>
    </notification>

    <div class="prompt is-hidden-mobile is-unselectable">
      <icon name="fa-cogs" />
      <p>
        Przejdź do odpowiedniej sekcji panelu administracyjnego za pomocą menu
        zlokalizowanego po lewej stronie
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Icon } from "%helpers";
import { Notification } from "%notifications";

import AdminViewHeader from "%admin/components/global/AdminViewHeader";

export default {
  name: "admin-landing-page",

  components: {
    Icon,
    Notification,
    AdminViewHeader
  },

  computed: mapGetters(["loggedUser", "jwtExpirationDate"])
};
</script>

<style lang="scss" scoped>
.prompt {
  text-align: center;
  color: $grey-lighter;

  .icon {
    font-size: 17rem;
  }

  p {
    font-family: $family-sans-serif-condensed;
    font-size: 1.5rem;
    margin: 0 auto;
    font-weight: 700;

    @include desktop {
      width: 50%;
    }
  }
}
</style>
